import classNames from 'classnames';
import { useIsInternalUser } from 'hooks/useIsInternalUser';
import type { IntlKey } from 'locales';
import type { NextWorkflowError } from 'models/NextWorkflowError';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { ModalAnchorTrigger } from '../ModalAnchorTrigger/ModalAnchorTrigger';
import type { WorkflowErrorDetailsListProps } from '../WorkflowError/WorkflowErrorDetailsList';
import { WorkflowErrorDetailsModal } from '../WorkflowError/WorkflowErrorDetailsModal';
import type { WorkflowErrorSummaryProps } from '../WorkflowError/WorkflowErrorSummary';
import { WorkflowErrorSummary } from '../WorkflowError/WorkflowErrorSummary';

export interface NextErrorsPanelBaseProps {
  id?: string;
  layout: 'summaryOnly' | 'summaryAndDetails';
  workflowErrors: readonly NextWorkflowError[];
  standardErrorMessage?: IntlKey;
  className?: string;
}

export type NextErrorsPanelProps = NextErrorsPanelBaseProps & WorkflowErrorSummaryProps & WorkflowErrorDetailsListProps;

// TODO: unit test by react-testing-library
export const NextErrorsPanel: FC<NextErrorsPanelProps> = ({
  id = 'errors-panel',
  layout: type,
  workflowErrors,
  shouldUseRejectionCode,
  productSubtype,
  standardErrorMessage,
  className = 'errors-panel-component',
}) => {
  const isInternal = useIsInternalUser();

  const { formatMessage } = useIntl();

  return (
    <div className={classNames('errors-panel-component', className)} data-e2e={id} id={id}>
      {standardErrorMessage && (
        <p>
          <strong className="align-middle">{formatMessage({ id: standardErrorMessage })}</strong>
        </p>
      )}
      <WorkflowErrorSummary
        productSubtype={productSubtype}
        shouldUseRejectionCode={shouldUseRejectionCode}
        workflowErrors={workflowErrors}
      />
      <br />
      {type === 'summaryAndDetails' && (
        <ModalAnchorTrigger id={`${id}-details-button`} text="seeErrorDetails">
          {({ isOn, toggle }) => (
            <WorkflowErrorDetailsModal
              errors={workflowErrors}
              isOpen={isOn}
              shouldDisplayErrorDetails={isInternal}
              toggle={toggle}
            />
          )}
        </ModalAnchorTrigger>
      )}
    </div>
  );
};
